import '../../scss/look-view.scss';

import {moodboardAddLookButtonStyleChange} from "../common/components/addLookToMoodboardButton";
const $ = require('jquery');
require('../common/share');
import {initFilters} from "../collection/filters";
const tts = require('../common/tts');

const hoverText = $('.look-affiliations-hovertext').html();
let affiliationName,
    currentItem;
initFilters();

$(document).ready(function () {
    detectAdblock();
    let item = $('.left-column').find('img');
    currentItem = camelCasedDataToSpinalCase(item.eq(0).data());
    document.addEventListener('login:true', (e) => {
        const addToMoodboardButton = document.querySelector('.add-to-moodboard-button');

        addToMoodboardButton.addEventListener('click', () => {
            const moodboardModule = require('../moodboard/add');

            if (addToMoodboardButton.classList.contains('add-to-moodboard-button-added') ||
                addToMoodboardButton.classList.contains('add-to-moodboard-button-clicked')) {
                return;
            }

            moodboardAddLookButtonStyleChange();

            let userInfo = e.detail;
            if (userInfo['email'].length != 0 && userInfo['job_title'] != null) {
                moodboardModule.initAddToMoodboard(currentItem);
            } else {
                moodboardModule.initNeedSubscription(currentItem);
            }
        })
    });
    $('.look-affiliations-item')
        .on('mouseenter', function () {
            affiliationName = $(this).find('.link-affiliations-item-name').html();
            $(this).find('.link-affiliations-item-name').html(hoverText);
        })
        .on('mouseleave', function () {
            $(this).find('.link-affiliations-item-name').html(affiliationName);
        });

    handleShopClickAnalytic(currentItem);
});

function detectAdblock() {
    if ($('#advertisement').css('display') === 'none') {
        $('.notice-unblock').show();
    }
}

/**
 * Loop object, change key (camelCase to spinalCase)
 *
 * @param {object} data
 *
 * @return {object}
 */
function camelCasedDataToSpinalCase(data){
    let tmp = {};
    for (const [k, v] of Object.entries(data)) {
        tmp[toSpinalCase(k)] = v;
    }

    return tmp;
}

/**
 * Parse string camelCase to spinalCase
 * return new string (spinalCase)
 *
 * @param str
 *
 * @return {string}
 */
function toSpinalCase(str) {
    return str.split('').map((c) => {
        if (c === c.toUpperCase()) {
            return '-' + c.toLowerCase();
        } else {
            return c;
        }
    })
        .join('');
}


const handleShopClickAnalytic = (currentItem) =>{
    const element = document.querySelector(".carousel-designer-shop-link");

    if (!element) {
        return;
    }

    let params = {
        'media_slug': currentItem['slug'],
        'route': document.querySelector('main')?.getAttribute('data-route') ?? null
    }

    element.addEventListener('click', () => {
        tts.click(element.getAttribute('href'), params);
    });
}
